import {
    headers,
    GET_LAYOUT_VIEW_AUDIT_TRACKER_LIST,GET_ZONE_DATA,
    BASE_URL,
} from "../../../utils/constants"
import { axiosGet } from "../../../react_axios/Axios"

const getLayoutViewAuditTrackerListUrl = `${BASE_URL}/layout/getHallLayout`;
const getZoneDataUrl = `${BASE_URL}/layout/getZoneData`;

// includeSvg = false lists the layouts without their drawings (IncludeSvg=0);
// fetch one layout's drawing by passing its LayoutID with includeSvg = true.
// A single response carrying every drawing grew past 80 MB and failed to load.
export const getLayoutViewAuditTrackerList_action = (ExhibitionID, LayoutID = null, includeSvg = true) => async (dispatch) => {
    try {
        const params = {
            ExhibitionID: ExhibitionID || sessionStorage.getItem('sessionExhibitionID'),
            ...(LayoutID && { LayoutID }),
            ...(!includeSvg && { IncludeSvg: 0 })
        }

        console.log('Calling API:', getLayoutViewAuditTrackerListUrl, 'with params:', params);
        const res = await axiosGet(getLayoutViewAuditTrackerListUrl, params, headers);
        console.log('API Response:', res);
        dispatch({
            type: GET_LAYOUT_VIEW_AUDIT_TRACKER_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        console.error("Error fetching layout data:", err);
        return Promise.reject(err);
    }
}

export const getZoneData_action = (HallID) => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            HallID: HallID,
        };

        console.log('Calling API:', getZoneDataUrl, 'with params:', params);
        const res = await axiosGet(getZoneDataUrl, params, headers);
        console.log('API Response:', res);
        dispatch({
            type: GET_ZONE_DATA,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        console.error("Error fetching zone data:", err);
        return Promise.reject(err);
    }
}